import Modifier from 'ember-modifier';
import { registerDestructor } from '@ember/destroyable';
import { cancel, throttle, scheduleOnce } from '@ember/runloop';

const cleanup = (instance) => {
  cancel(instance.timeout);

  instance.element.style.height = null;
  instance.element.style.overflow = null;

  window.removeEventListener('resize', instance.scheduleResize);
};

class MessageComposerResizeModifier extends Modifier {
  element = null;
  timeout = null;

  #initialized = false;
  #initialHeight = 0;
  #lineHeight = 0;

  scheduleResize = () => {
    this.timeout = throttle(this, this.resize, 150, false);
  };

  constructor() {
    super(...arguments);
    registerDestructor(this, cleanup);
  }

  // need to entangle the `value` prop so that it triggers auto-tracking
  // eslint-disable-next-line no-unused-vars
  modify(element, [value]) {
    if (!this.timeout) {
      if (!this.#initialized) {
        this.element = element;
        this.timeout = scheduleOnce('afterRender', this, this.initialize);
      } else {
        this.resize();
      }
    }
  }

  initialize() {
    const { element } = this;
    const { height, lineHeight } = window.getComputedStyle(element);

    this.#initialHeight = Number.parseFloat(height);
    this.#lineHeight = Number.parseFloat(lineHeight);
    this.#initialized = true;
    this.resize();

    window.addEventListener('resize', this.scheduleResize, { passive: true });
  }

  resize() {
    this.timeout = null;

    const initialHeight = this.#initialHeight;
    const element = this.element;

    element.classList.add('auto-resize-measure');
    const scrollHeight = element.scrollHeight;
    element.classList.remove('auto-resize-measure');

    if (scrollHeight <= initialHeight) {
      element.style.height = `${initialHeight}px`;
      element.style.overflow = 'hidden';
    } else if (scrollHeight < (window.innerHeight / 3)) {
      element.style.height = `${scrollHeight}px`;
      element.style.overflow = 'hidden';
    } else {
      const lineHeight = this.#lineHeight;
      element.style.height = `${Math.floor((window.innerHeight / 3) / lineHeight) * lineHeight}px`;
      element.style.overflow = 'auto';
    }
  }
}

export default MessageComposerResizeModifier;
